import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FlexBox, FlexBoxColumn, FlexBoxSpaceBetween } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';

import { formatAgoTimeString } from '@bo-utils/dateUtils';
import { alarmPopupState } from '@bo-recoil/common/alarm/atom';
import CommonApi from '@bo-apis/common/commonApi';
import { useAlarmTemplate } from '@bo-layout/gnb/alarm/useAlarmTemplate';

const AlarmItem = ({ alarmType, alarmParameter, moreCount, registerTime }) => {
  const navigate = useNavigate();
  const { getContents } = useAlarmTemplate();
  const { colorInfo, buttonText, bodyTitle, bodyText, linkUrl } = getContents(alarmType, alarmParameter);
  const setPopupOpen = useSetRecoilState(alarmPopupState);

  const handleAlarmItemClick = async () => {
    const result = await CommonApi.changeReadStatus({ alarmType });
    if (result) {
      navigate(linkUrl);
      setPopupOpen(false);
    }
  };

  return (
    <AlarmItemWrapper onClick={handleAlarmItemClick}>
      <FlexBox gap={'8px'}>
        <RoundButtonText style={{ ...colorInfo }}>{buttonText}</RoundButtonText>
        <TextBox font-size={13} font-weight={400} color={'#333'}>
          {moreCount > 1 ? `+${moreCount}` : ''}
        </TextBox>
      </FlexBox>
      <Spacing top={14} />
      <FlexBoxSpaceBetween width={'100%'}>
        <FlexBoxColumn align-items={'start'}>
          <TextBox
            font-size={16}
            style={{
              fontWeight: '700',
              maxWidth: '280px',
              overflowWrap: 'anywhere',
            }}
          >
            {bodyTitle}
          </TextBox>
          <TextBox font-size={13} font-weight={400}>
            {bodyText}
          </TextBox>
        </FlexBoxColumn>
        <RoundButtonText style={{ height: '30px', backgroundColor: '#fff', border: '1px solid #EEEEEE' }}>
          {formatAgoTimeString(registerTime)}
        </RoundButtonText>
      </FlexBoxSpaceBetween>
    </AlarmItemWrapper>
  );
};

const AlarmItemWrapper = styled(FlexBoxColumn)`
  width: 100%;
  min-height: 50px;
  background-color: #f8f8f8;
  border: #eee;
  padding: 15px;
  cursor: pointer;
  align-items: flex-start;
  justify-content: flex-start;
  border: 1px solid #eeeeee;
`;

AlarmItem.propTypes = {
  alarmType: PropTypes.string,
  alarmParameter: PropTypes.string,
  moreCount: PropTypes.number,
  registerTime: PropTypes.string,
};

const RoundButtonText = styled(FlexBox)`
  height: 24px;
  border-radius: 60px;
  padding: 10px 10px;
  font-size: 12px;
  font-weight: 400;
  min-width: 90px;
  justify-content: center;
`;

export default AlarmItem;
